import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Alert, Box, Button, Checkbox, FormControlLabel, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Login } from 'app/shared/layout/login/Login';
import { getSession, login } from 'app/shared/reducers/authentication';
import React, { useEffect, useState } from 'react';
import { Storage, Translate, translate } from 'react-jhipster';
import { Link, useHistory } from 'react-router-dom';

const HomeLoginForm = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const AUTH_TOKEN_KEY = 'app-authenticationToken';
  const loginError = useAppSelector(state => state.authentication.loginError);
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    if (token) {
      try {
        const decodedToken = atob(token);
        Storage.session.set(AUTH_TOKEN_KEY, decodedToken);
        dispatch(getSession());
      } catch (error) {
        console.error('Error decoding token:', error);
        return;
      }

      history.replace('/');
    }
  }, []);

  const handleLogin = () => {
    dispatch(login(username, password, rememberMe));
  };

  const handleSubmit = event => {
    event.preventDefault();
    handleLogin();
  };

  return (
    <Login>
      <Typography
        fontWeight={700}
        component="h1"
        variant="h5"
        align="center"
        sx={{ mb: { xs: 4, md: 6 }, mt: { xs: 6, md: 8 }, color: 'text.primary', fontFamily: '"Familjen Grotesk", sans-serif', letterSpacing: '0.05em' }}
      >
        <Translate contentKey="login.title">Sign in</Translate>
      </Typography>
      <Grid container spacing={3} sx={{ minHeight: '380px', alignItems: 'center' }}>
        <Grid component="form" onSubmit={handleSubmit} item xs={12} sm={12}>
          <TextField
            name="username"
            type="text"
            label={translate('global.form.username.placeholder')}
            variant="outlined"
            required
            autoFocus
            fullWidth
            color="primary"
            data-cy="username"
            value={username}
            onChange={event => setUsername(event.target.value)}
            inputProps={{
              maxLength: 50,
              style: { color: 'primary' },
            }}
            InputProps={{
              style: { borderRadius: '8px' },
            }}
          />
          <TextField
            name="password"
            type={showPassword ? 'text' : 'password'}
            label={translate('login.form.password.placeholder')}
            variant="outlined"
            required
            fullWidth
            color="primary"
            data-cy="password"
            value={password}
            onChange={event => setPassword(event.target.value)}
            inputProps={{
              minLength: 4,
              maxLength: 100,
            }}
            InputProps={{
              style: { borderRadius: '8px', marginRight: '8px' },
              endAdornment: (
                <InputAdornment position="end" style={{ marginRight: '5px' }}>
                  <IconButton edge="end" onClick={() => setShowPassword(!showPassword)} color="primary">
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              mt: { xs: 4 },
              mb: { xs: 2 },
            }}
          />
          <FormControlLabel
            control={<Checkbox color="primary" name="rememberme" onChange={event => setRememberMe(event.target.checked)} />}
            label={
              <Typography sx={{ color: 'text.secondary' }}>
                <Translate contentKey="login.form.rememberme">Do you want to be remembered?</Translate>
              </Typography>
            }
          />
          <Grid item xs={12} sm={12}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              color="primary"
              sx={{
                mt: { xs: 5, md: 3 },
                fontWeight: 700,
                '&:hover': { backgroundColor: 'primary.dark' },
              }}
            >
              <Translate contentKey="login.form.button">Sign in</Translate>
            </Button>
            {loginError && (
              <Alert severity="error" data-cy="loginError">
                <Translate contentKey="login.messages.error.authentication">Please check your credentials and try again.</Translate>
              </Alert>
            )}
            <Box component={Link} to="/account/reset/request" className="forget-password" data-cy="forgetYourPasswordSelector">
              <Typography component="span" mt={1} display="block" color={'primary.light'} sx={{ mb: { xs: 4, md: 6 } }}>
                <Translate contentKey="login.password.forgot">Did you forget your password?</Translate>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Login>
  );
};
export default HomeLoginForm;
